import { useContext } from "react";
import { AppContext } from "contexts/AppContext";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { translate } from "utils/Translate";
import Activity from "utils/Activity";
import ContentNormal from "components/elements/ContentNormal";
import BannerSection from "components/blocks/bannerSection/bannerSection";
import useWindowWidth from "utils/useWindowWidth";
import Headline3 from "components/elements/Headline3";
import Headline2 from "components/elements/Headline2";
import ButtonMedium4 from "components/elements/ButtonMedium4";

const FrontPageBanner = () => {
    const navigate = useNavigate()
    const windowWidth = useWindowWidth()
    const { brandData, langCode, accessibleShops, styleGuide } = useContext(AppContext);
    const { frontPageBannerTitle, frontPageBannerContent, frontPageBannerBackgroundColor, frontPageTextColorBlack, frontPageBannerImageUrl } = brandData?.features
    const ShopID = accessibleShops && accessibleShops.length > 0 ? accessibleShops[0].ShopID : null
    
    const textColor = frontPageTextColorBlack ? styleGuide.color18 : styleGuide.color1
    const title = (frontPageBannerTitle
        ? !!frontPageBannerTitle[langCode]
            ? frontPageBannerTitle[langCode]
            : frontPageBannerTitle
        : ''
    ) || 'Overskrift for velkomst'

    const text = (frontPageBannerContent
        ? !!frontPageBannerContent[langCode]
            ? frontPageBannerContent[langCode]
            : frontPageBannerContent
        : ''
    ) || 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'

    const htmlDecode = (input) => {
        const e = document.createElement('div');
        e.innerHTML = input;
        return e.childNodes[0].nodeValue;
    }

    const extraButtons = brandData?.features?.frontPageBannerButtons || []
    extraButtons.sort((a, b) => a.poolOrder - b.poolOrder)

    return (
        <BannerSection bannerImageUrl={frontPageBannerImageUrl} backgroundColor={frontPageBannerBackgroundColor || styleGuide.color3} backgroundHeightPct={80} textBackgroundColor={styleGuide.color14} headerSection>
            <Box flex={1} display={'flex'} justifyContent={{xs: 'left', md: 'center'}} padding={{xs: '20px 20px 40px 20px', sm: '32px 32px 48px 32px', lg: 8, xl: 18}}>
                <Box display={'flex'} flexDirection={'column'} gap={4}>
                    <Box display={'flex'} flexDirection={'column'} gap={3}>
                        {windowWidth < 1800
                            ?
                                <Headline3>
                                    <span
                                        style={{ color: textColor }}
                                        dangerouslySetInnerHTML={{ __html: htmlDecode(translate('_BANNER_HEADLINE_', title)) }}
                                    />
                                </Headline3>
                            :
                                <Headline2>
                                    <span
                                        style={{ color: textColor }}
                                        dangerouslySetInnerHTML={{ __html: htmlDecode(translate('_BANNER_HEADLINE_', title)) }}
                                    />
                                </Headline2>
                        }
                        <ContentNormal>
                            <span
                                style={{ color: textColor }}
                                dangerouslySetInnerHTML={{ __html: htmlDecode(translate('_BANNER_CONTENT_', text)) }}
                            />
                        </ContentNormal>
                    </Box>
                    <Box display={'flex'} flexWrap={'wrap'} gap={2}>
                        {extraButtons.filter(b => b.poolOrder < 0).map(b => (
                            <FrontPageButton
                                buttonText={b.buttonText}
                                textColor={textColor}
                                buttonLink={b.buttonLink}
                            />
                        ))}
                        {!!ShopID &&
                            <ButtonMedium4
                                translationKey={'_HOME_BANNER_BUTTON_TEXT_'}
                                fallbackText={'Shop'}
                                color={textColor}
                                onClick={() => {
                                    Activity({ activityType: 'click', activityName: 'home', activityArgument: 'Shop', activityArgumentID: ShopID })
                                    navigate(`/shop/${ShopID}`, { state: { scrollToTop: true } })
                                }}
                            />
                        }
                        {extraButtons.filter(b => b.poolOrder >= 0).map(b => (
                            <FrontPageButton
                                buttonText={b.buttonText}
                                textColor={textColor}
                                buttonLink={b.buttonLink}
                            />
                        ))}
                    </Box>
                </Box>
            </Box>
        </BannerSection>
    )
}

const FrontPageButton = (props) => {
    const { buttonText, buttonLink, textColor } = props
    const navigate = useNavigate()

    return (
        <ButtonMedium4
            fallbackText={buttonText}
            color={textColor}
            onClick={() => {
                navigate(buttonLink)
            }}
        />
    )
}

export default FrontPageBanner